function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var DocumentInfo = function DocumentInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#222222",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1,
    d: "M13.734 1c.796 0 1.547.31 2.113.871l4.266 4.236A3.02 3.02 0 0 1 21 8.236V20c0 1.654-1.406 3-3.134 3H6.133C4.405 23 3 21.654 3 20V4c0-1.654 1.405-3 3.133-3zm-.696 2H6.133C5.508 3 5 3.448 5 4v16c0 .552.508 1 1.133 1h11.733c.625 0 1.134-.448 1.134-1V8.645h-2.96c-1.655 0-3-1.345-3-3zM12 12.84a1 1 0 0 1 1 1v4.416a1 1 0 1 1-2 0V13.84a1 1 0 0 1 1-1m0-4.028a1.25 1.25 0 1 1-.001 2.498 1.25 1.25 0 0 1 0-2.498m3.038-4.924.001 1.758c0 .551.45 1 1 1l1.776-.001z"
  }));
};
export default DocumentInfo;